<div class="map-header-content" fxLayout="column">
    <ng-container *ngIf="isAssetSelected">
        <app-selected-asset-navigation 
            (closeButtonClicked)="closeButtonClicked()"
            [asset]="asset"
            [subContextView]="subContextView"
            (subContextChange)="handleSubContextChange($event)"
        ></app-selected-asset-navigation>
    </ng-container>
</div>